import { render, staticRenderFns } from "./widget-details.vue?vue&type=template&id=42469119&"
import script from "./widget-details.ts?vue&type=script&lang=ts&"
export * from "./widget-details.ts?vue&type=script&lang=ts&"
import style0 from "./widget-details.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports